module.exports = __webpack_public_path__ + "static/sport/bgi.78376a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sport/bgi.png
// module id = gN0G
// module chunks = 0